module.exports = __webpack_public_path__ + "img/icon_tap_08.26b418ec.svg";